import React, {
  useState,
  useCallback,
  useMemo,
  FC,
}                                from 'react';
import { History }               from 'history';
import { ISearchInvoice }        from '@typings/invoiceManagement';
import {
  ISearchParams,
  ISearchFilter,
}                                from '@typings/search';
import { EAppPage }              from '@enums/common';
import { EInvoiceProperty }      from '@enums/invoiceManagement';
import { EAccountPage }          from '@enums/accountManagement';
import {
  useFetchInvoiceStats,
  useFetchInvoices,
}                                from '@modules/invoiceManagement/queries/invoiceManagementQueries';
import {
  parseRecords,
  isObjectEmpty,
}                                from '@utils/commonFunctions';
import { InvoiceManagementPage } from '@modules/invoiceManagement/pages/InvoiceManagementPage';

export const InvoiceManagementContainer: FC<Pick<History, 'push'>> = ({ push }) => {
  const [showWarning, setShowWarning]       = useState<boolean>(false);
  const [searchProperty, setSearchProperty] = useState<EInvoiceProperty | null>(null);
  const [searchValue, setSearchValue]       = useState<string>('');

  const params = useMemo<ISearchParams>(
    () => {
      if (!searchValue || !searchProperty) {
        return {};
      }

      const searchText : string          = searchProperty === EInvoiceProperty.Number ? '*' : searchValue;
      const filters    : ISearchFilter[] = searchProperty === EInvoiceProperty.Number
        ? [{
          propertyName : searchProperty,
          operator     : 'eq',
          value        : Number(searchValue),
        }]
        : [];

      return {
        offset : 0,
        limit  : 1,
        searchText,
        filters,
      };
    },
    [searchProperty, searchValue],
  );

  // #region API INTEGRATION
  const { data: statistics = null } = useFetchInvoiceStats();

  useFetchInvoices(
    params,
    {
      enabled   : !isObjectEmpty(params),
      onSuccess : (data) => {
        const [invoiceResult = null] = parseRecords<ISearchInvoice>(data);

        if (invoiceResult) {
          push(`${EAppPage.AccountManagement}/${invoiceResult.cuid}/${EAccountPage.Invoices}/${invoiceResult.id}`);
        } else {
          setShowWarning(true);
        }
      },
    },
  );
  // #endregion

  const onInvoiceSearch = useCallback(
    (searchText: string, searchProp: EInvoiceProperty): void => {
      setSearchValue(searchText);
      setSearchProperty(searchProp);
    },
    [],
  );

  return (
    <InvoiceManagementPage
      push            = {push}
      statistics      = {statistics}
      showWarning     = {showWarning}
      onInvoiceSearch = {onInvoiceSearch}
    />
  );
};
